/*!
 * Error tracking for Snowplow v0.3.11 (http://bit.ly/sp-js)
 * Copyright 2022 Snowplow Analytics Ltd, 2010 Anthon Pang
 * Licensed under BSD-3-Clause
 */
"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

!function (n, o) {
  "object" == (typeof exports === "undefined" ? "undefined" : _typeof(exports)) && "undefined" != typeof module ? o(exports) : "function" == typeof define && define.amd ? define(["exports"], o) : o((n = "undefined" != typeof globalThis ? globalThis : n || self).snowplowErrorTracking = {});
}(this, function (n) {
  function o(n, o, e) {
    if (e || 2 === arguments.length) for (var r, t = 0, c = o.length; t < c; t++) {
      !r && t in o || (r || (r = Array.prototype.slice.call(o, 0, t)), r[t] = o[t]);
    }
    return n.concat(r || Array.prototype.slice.call(o));
  }

  function e(n, o) {
    void 0 === o && (o = Object.keys(u));
    var e = n.message,
        r = n.filename,
        t = n.lineno,
        c = n.colno,
        i = n.error,
        a = n.context,
        l = n.timestamp,
        f = i && i.stack ? i.stack : null;
    void 0 === e || null === e && void 0 === f || null === f && void 0 === t || null === t && void 0 === c || null === c && void 0 === r || null === r || function (n, o, e) {
      try {
        var r = null != n ? n : Object.keys(o);
        n = [];

        for (var t = 0; t < r.length; t++) {
          var c = r[t];
          o.hasOwnProperty(c) ? n.push(o[c]) : s.warn(c + " not configured");
        }

        n.forEach(e);
      } catch (n) {
        s.error("Function failed", n);
      }
    }(o, u, function (n) {
      if (n.core.getConfig().exceptionAutotracking) {
        var o = (n = n.core).track,
            i = {
          programmingLanguage: "JAVASCRIPT",
          message: null != e ? e : "JS Exception.",
          stackTrace: f,
          lineNumber: t,
          lineColumn: c,
          fileName: r
        },
            s = function () {
          var n,
              o = {},
              e = [],
              r = [],
              t = [],
              c = function c(n, e) {
            null != e && "" !== e && (o[n] = e);
          };

          return {
            add: c,
            addDict: function addDict(n) {
              for (var o in n) {
                Object.prototype.hasOwnProperty.call(n, o) && c(o, n[o]);
              }
            },
            addJson: function addJson(n, o, t) {
              var c;
              if (c = t) n: {
                if (null != t && (t.constructor === {}.constructor || t.constructor === [].constructor)) for (var i in t) {
                  if (Object.prototype.hasOwnProperty.call(t, i)) {
                    c = !0;
                    break n;
                  }
                }
                c = !1;
              }
              c && (n = {
                keyIfEncoded: n,
                keyIfNotEncoded: o,
                json: t
              }, r.push(n), e.push(n));
            },
            addContextEntity: function addContextEntity(n) {
              t.push(n);
            },
            getPayload: function getPayload() {
              return o;
            },
            getJson: function getJson() {
              return e;
            },
            withJsonProcessor: function withJsonProcessor(o) {
              n = o;
            },
            build: function build() {
              return null == n || n(this, r, t), o;
            }
          };
        }();

        i = {
          sc: "sp/ue/1-0-0",
          dt: {
            sc: "sp/ae/1-0-1",
            dt: i
          }
        }, s.add("e", "ue"), s.addJson("ue_px", "ue_pr", i), o.call(n, s, a, l);
      }
    });
  }

  var r, t;
  (t = r || (r = {}))[t.none = 0] = "none", t[t.error = 1] = "error", t[t.warn = 2] = "warn", t[t.debug = 3] = "debug", t[t.info = 4] = "info";

  var c,
      i,
      a,
      l,
      s = function (n) {
    return void 0 === n && (n = r.warn), {
      setLogLevel: function setLogLevel(o) {
        n = r[o] ? o : r.warn;
      },
      warn: function warn(e, t) {
        for (var c = [], i = 2; i < arguments.length; i++) {
          c[i - 2] = arguments[i];
        }

        n >= r.warn && "undefined" != typeof console && (i = "Conviva: " + e, t ? console.warn.apply(console, o([i + "\n", t], c, !1)) : console.warn.apply(console, o([i], c, !1)));
      },
      error: function error(e, t) {
        for (var c = [], i = 2; i < arguments.length; i++) {
          c[i - 2] = arguments[i];
        }

        n >= r.error && "undefined" != typeof console && (i = "Conviva: " + e + "\n", t ? console.error.apply(console, o([i + "\n", t], c, !1)) : console.error.apply(console, o([i], c, !1)));
      },
      debug: function debug(e) {
        for (var t = [], c = 1; c < arguments.length; c++) {
          t[c - 1] = arguments[c];
        }

        n >= r.debug && "undefined" != typeof console && console.debug.apply(console, o(["Conviva: " + e], t, !1));
      },
      info: function info(e) {
        for (var t = [], c = 1; c < arguments.length; c++) {
          t[c - 1] = arguments[c];
        }

        n >= r.info && "undefined" != typeof console && console.info.apply(console, o(["Conviva: " + e], t, !1));
      }
    };
  }();

  !function (n) {
    n.response_body = "rsb", n.request_body = "rqb", n.response_headers = "rsh", n.request_headers = "rqh";
  }(c || (c = {})), function (n) {
    n.response_body = "rsb", n.request_body = "rqb", n.response_headers = "rsh", n.request_headers = "rqh";
  }(i || (i = {})), function (n) {
    var o;
    n.TRACEPARENT_HEADER_KEY = "traceparent", (o = n.CONFIG_PREFERENCES || (n.CONFIG_PREFERENCES = {}))[o.APP = 0] = "APP", o[o.REMOTE = 1] = "REMOTE", o[o.MERGE = 2] = "MERGE", function (n) {
      n[n.DISABLED = 0] = "DISABLED", n[n.PERFORMANCE_TIMING = 1] = "PERFORMANCE_TIMING", n[n.PERFORMANCE_NAVIGATION_TIMING = 2] = "PERFORMANCE_NAVIGATION_TIMING";
    }(n.PERFORMANCE_CONTEXT || (n.PERFORMANCE_CONTEXT = {})), n.REMOTE_CONFIG_STORAGE_KEY = "ConvivaRemoteConfig", n.END_POINT_STORAGE_KEY = "ConvivaEndpoint", n.DEFAULT_END_POINT = "https://appgw.conviva.com", n.REMOTE_CONFIG_URL_PREFIX = "https://rc.conviva.com/js/", n.REMOTE_CONFIG_FILE_NAME = "/remote_config.json";
  }(a || (a = {})), function (n) {
    n[n.APP = 0] = "APP", n[n.REMOTE = 1] = "REMOTE", n[n.MERGE = 2] = "MERGE";
  }(l || (l = {}));
  var u = {};
  n.ErrorTrackingPlugin = function () {
    return {
      activateBrowserPlugin: function activateBrowserPlugin(n) {
        u[n.id] = n;
      }
    };
  }, n.enableErrorTracking = function (n, o) {
    void 0 === n && (n = {}), void 0 === o && (o = Object.keys(u));

    try {
      var r = n.filter,
          t = n.contextAdder,
          c = n.context;
      !function (n, o, e, r) {
        n.addEventListener ? n.addEventListener(o, e, r) : n.attachEvent ? n.attachEvent("on" + o, e) : n["on" + o] = e;
      }(window, "error", function (n) {
        try {
          if (r && r && "function" == typeof r && r(n) || null == r) {
            var i = o,
                a = c || [];
            t && t && "function" == typeof t && (a = a.concat(t(n))), e({
              message: n.message,
              filename: n.filename,
              lineno: n.lineno,
              colno: n.colno,
              error: n.error,
              context: a
            }, i);
          }
        } catch (n) {
          console.warn("Conviva App Tracker caused Exception in enableErrorTracking callback of error tracking Plugin", n);
        }
      }, !0);
    } catch (n) {
      console.warn("Conviva App Tracker caused Exception in enableErrorTracking method of error tracking Plugin", n);
    }
  }, n.trackError = e, Object.defineProperty(n, "__esModule", {
    value: !0
  });
});